/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import "material-icons/iconfont/material-icons.css"; //Material Icons
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

import { io } from "socket.io-client";
import VueSocketIOExt from "vue-socket.io-extended";

const socket = io(process.env.VUE_APP_SOCKET_IO_URL, {
  transports: ["websocket"],
  upgrade: false,
});

socket.on("connect", function () {
  /* const sessionID = socket.socket.sessionid;  */
  console.log(socket.id);
  console.log("socket", socket);

  /*   this.socket.$subscribe("WELCOME", (payload) => {
    console.log("admin page received WELCOME", payload);
  }); */

  /* this.socket.$subscribe("NEW_ORDER", (payload) => {
    console.log(payload);
    console.log("admin page received NEW_ORDER");
    this.$store.commit("orders/ADD_NEW_ORDER_PAID", payload);
    var audio = new Audio(
      "http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3"
    );
    audio.play();
    this.$vs.notify({
      title: "Neue Bestellung eingetroffen",
      text: "Klicke mich, um diese Information zu schließen",
      color: "#b71c1c",
      position: "top-right",
      fixed: true,
      click: () => {
        console.log("...");
      },
    });
  }); */

  /*   this.socket.$subscribe("NEW_MESSAGE", () => {
    var audio = new Audio(
      "http://soundbible.com/mp3/Air Plane Ding-SoundBible.com-496729130.mp3"
    );
    audio.play();
    this.$vs.notify({
      title: "Neue Kundennachricht eingetroffen",
      text: "Klicke mich, um diese Information zu schließen",
      color: "primary",
      position: "top-right",
      fixed: true,
      click: () => {
        console.log("...");
      },
    });
  }); */
});

Vue.use(VueSocketIOExt, socket);

require("./store/subscriber");

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  new Vue({
    router,
    store,
    sockets: {
      connect() {
        console.log("socket connected XXXX");
      },
      customEmit() {
        console.log(
          'this method was fired by the socket server. eg: io.emit("customEmit", data)',
        );
      },
    },
    render: (h) => h(App),
  }).$mount("#app");
});

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Filters
import "./filters/filters";

// Moment js filter
const moment = require("moment");
require("moment/locale/de");
moment.locale("de");
Vue.use(require("vue-moment"), { moment });

// Vuex Store
import store from "./store/store";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;
